import { load } from '@fingerprintjs/botd';

import tracking from '@glass/shared/modules/tracking';

export default typeof window !== 'undefined'
  ? load({ monitoring: false })
      .then((botDetector) => botDetector.detect())
      .catch(tracking.exception)
  : null;
